import axios from 'axios'
import qs from 'qs'
import router from '@/router/index.js'
import {
	Notification,
	Message
} from 'element-ui'
import store from '../store'



// 创建 axios 实例
var requests = axios.create({
	//   baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
	// baseURL: 'http://api.kkzh.com/',
	// baseURL: 'https://api.bbzsh.com/',
	// baseURL: 'http://127.0.0.1:20004/',
	// baseURL: 'https://bbzsh.com/api-server/',
	baseURL: 'https://zuhao.bbzsh.com/api-server/',
	// baseURL: 'https://api.h6ds.com',
	timeout: 6000, // 请求超时时间
	responseType: 'json',
	// withCredentials: true,
})

requests.interceptors.request.use(
	req => {
		var token = localStorage.getItem('usertoken')
		if (!req.data) {
			req.data = {}
		}
		req.data.token = token
		req.data.backupModeEnabled = store.state.backupModeEnabled ? 1 : 0
		
		req.data = qs.stringify(req.data);
		req.headers = {
			"Content-Type": "application/x-www-form-urlencoded"
		}

	

		return req
	},
	e => {



	}
)





// 错误处理函数
const err = (error) => {




	if (error.response) {
		const data = error.response.data
		// const token = Vue.ls.get(ACCESS_TOKEN)
		if (error.response.status === 403) {
			//         Notify({ type: 'danger', message: data.message||data.msg });
		}
		if (error.response.status === 401) {

			Message.error({
				message: '请先登录',
				duration: 3000,
				// offset: "580"
			})
			store.commit('SET_open_login', true)
			


			//         Notify({ type: 'danger', message: '你没有权限。' });
			// if (token) {
			//   store.dispatch('Logout').then(() => {
			//     setTimeout(() => {
			//       window.location.reload()
			//     }, 1500)
			//   })
			// }
		}
	}
	return Promise.reject(error)
}



// request interceptor(请求拦截器)
// requests.interceptors.request.use(config => {
// //   const token = Vue.ls.get(ACCESS_TOKEN)
//   const token = localStorage.getItem('token')
//   if (token) {
//     config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
//   }
//   return config
// }, err)



// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
	const res = response.data

	console.log('Response:', response.status, res.code, res.msg);

	if (res.code !== 1 && res.code !== 200) {
		if (res.code === 500) {
			Message.error({
				message: res.msg || '服务器内部错误',
				duration: 3000,
			})
		}
		if (res.code === 401 || res.code === 403 || res.code === 999) {

		}

		const error = new Error(res.msg || '请求失败')
		error.response = response
		error.code = res.code
		return Promise.reject(error)
	} else {
		return res
	}
}, err)



export default {
	requests
}